import React, {  useCallback, useMemo } from 'react';
import { Image } from 'lucide-react'; // Placeholder icon

const ImageViewerCard = ({ item, openImageModal }) => {

    // Memoize theme-based class names
    const themeClasses = useMemo(() => ({
        // FIX 1: Removed background colors. Added shadow and transition
        cardBg: 'bg-card-light dark:bg-card-dark shadow-md hover:shadow-xl transition duration-300 dark:shadow-none', 
        cardTitle: 'text-text-light dark:text-text-dark',
        cardText: 'text-muted-light dark:text-muted-dark',

        // Using primary color (Teal) for tags in both modes
        badge: 'bg-primary/15 text-primary dark:bg-primary/20 dark:text-primary', 
    }), []);

    // Handle image error
    const handleImageError = useCallback((e) => {
        e.target.onerror = null;
        e.target.src = '/images/default-gallery.webp'; // Fallback image
    }, []);

    // Handle hover effect on the image
    const handleHover = useCallback((e, scale) => {
        e.currentTarget.style.transform = `scale(${scale})`;
    }, []);

    return (
        <div className="w-full h-full">
            <div
                // FIX 2: Added subtle border in light mode for definition (optional)
                className={`h-full flex flex-col rounded-xl overflow-hidden cursor-pointer ${themeClasses.cardBg} border border-transparent dark:border-transparent`}
                onClick={() => openImageModal(item)}
                aria-label={`View image: ${item.title}`}
            >
                {/* Image Area */}
                <div className="relative h-60 overflow-hidden">
                    {item.image ? (
                        <img
                            src={item.image}
                            alt={item.title}
                            className="h-full w-full object-cover transition-transform duration-300 ease-in-out"
                            loading="lazy"
                            style={{
                                objectPosition: `center ${typeof item.imageOffsetY === 'number'
                                    ? `${item.imageOffsetY}%`
                                    : item.imageOffsetY || '50%'}`,
                            }}
                            onMouseEnter={(e) => handleHover(e, 1.05)}
                            onMouseLeave={(e) => handleHover(e, 1.0)}
                            onError={handleImageError}
                        />
                    ) : (
                        <div className="flex justify-center items-center h-full bg-gray-200 dark:bg-gray-700">
                            <Image size={32} className="text-gray-400 dark:text-gray-500" />
                        </div>
                    )}
                    <div className="absolute top-3 right-3">
                        <span className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${themeClasses.badge}`}>
                            {item.category}
                        </span>
                    </div>
                </div>

                {/* Text Content */}
                <div className="p-4 flex flex-col flex-grow">
                    <h5 className={`text-lg font-semibold mb-1 ${themeClasses.cardTitle} line-clamp-1`}>
                        {item.title}
                    </h5>
                    <p className={`text-sm ${themeClasses.cardText} mb-2 line-clamp-2 flex-grow`}>
                        {item.description}
                    </p>
                    <div className="flex justify-end items-center mt-auto pt-2 border-t border-border-light dark:border-border-dark">
                        <small className={`text-xs ${themeClasses.cardText}`}>
                            {item.date}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ImageViewerCard);